"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.constructJobCorrelator = exports.complete = exports.setup = void 0;
const core = __importStar(require("@actions/core"));
const github = __importStar(require("@actions/github"));
const glob = __importStar(require("@actions/glob"));
const artifact_1 = require("@actions/artifact");
const request_error_1 = require("@octokit/request-error");
const path = __importStar(require("path"));
const fs_1 = __importDefault(require("fs"));
const layout = __importStar(require("./repository-layout"));
const input_params_1 = require("./input-params");
const DEPENDENCY_GRAPH_PREFIX = 'dependency-graph_';
function setup(option) {
    return __awaiter(this, void 0, void 0, function* () {
        if (option === input_params_1.DependencyGraphOption.Disabled) {
            return;
        }
        if (option === input_params_1.DependencyGraphOption.DownloadAndSubmit) {
            yield downloadAndSubmitDependencyGraphs();
            return;
        }
        core.info('Enabling dependency graph generation');
        core.exportVariable('GITHUB_DEPENDENCY_GRAPH_ENABLED', 'true');
        core.exportVariable('GITHUB_DEPENDENCY_GRAPH_JOB_CORRELATOR', getJobCorrelator());
        core.exportVariable('GITHUB_DEPENDENCY_GRAPH_JOB_ID', github.context.runId);
        core.exportVariable('GITHUB_DEPENDENCY_GRAPH_REF', github.context.ref);
        core.exportVariable('GITHUB_DEPENDENCY_GRAPH_SHA', getShaFromContext());
        core.exportVariable('GITHUB_DEPENDENCY_GRAPH_WORKSPACE', layout.workspaceDirectory());
        core.exportVariable('DEPENDENCY_GRAPH_REPORT_DIR', path.resolve(layout.workspaceDirectory(), 'dependency-graph-reports'));
    });
}
exports.setup = setup;
function complete(option) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            switch (option) {
                case input_params_1.DependencyGraphOption.Disabled:
                case input_params_1.DependencyGraphOption.Generate:
                case input_params_1.DependencyGraphOption.DownloadAndSubmit:
                    return;
                case input_params_1.DependencyGraphOption.GenerateAndSubmit:
                    yield submitDependencyGraphs(yield findGeneratedDependencyGraphFiles());
                    return;
                case input_params_1.DependencyGraphOption.GenerateAndUpload:
                    yield uploadDependencyGraphs(yield findGeneratedDependencyGraphFiles());
            }
        }
        catch (e) {
            core.warning(`Failed to ${option} dependency graph. Will continue. ${String(e)}`);
        }
    });
}
exports.complete = complete;
function findGeneratedDependencyGraphFiles() {
    return __awaiter(this, void 0, void 0, function* () {
        const workspaceDirectory = layout.workspaceDirectory();
        return yield findDependencyGraphFiles(workspaceDirectory);
    });
}
function uploadDependencyGraphs(dependencyGraphFiles) {
    return __awaiter(this, void 0, void 0, function* () {
        const workspaceDirectory = layout.workspaceDirectory();
        const artifactClient = new artifact_1.DefaultArtifactClient();
        for (const dependencyGraphFile of dependencyGraphFiles) {
            const relativePath = getRelativePathFromWorkspace(dependencyGraphFile);
            core.info(`Uploading dependency graph file: ${relativePath}`);
            const artifactName = `${DEPENDENCY_GRAPH_PREFIX}${path.basename(dependencyGraphFile)}`;
            yield artifactClient.uploadArtifact(artifactName, [dependencyGraphFile], workspaceDirectory, {
                retentionDays: (0, input_params_1.getArtifactRetentionDays)()
            });
        }
    });
}
function downloadAndSubmitDependencyGraphs() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield submitDependencyGraphs(yield downloadDependencyGraphs());
        }
        catch (e) {
            core.warning(`Download and submit dependency graph failed. Will continue. ${String(e)}`);
        }
    });
}
function submitDependencyGraphs(dependencyGraphFiles) {
    return __awaiter(this, void 0, void 0, function* () {
        for (const jsonFile of dependencyGraphFiles) {
            try {
                yield submitDependencyGraphFile(jsonFile);
            }
            catch (error) {
                if (error instanceof request_error_1.RequestError) {
                    core.warning(buildWarningMessage(jsonFile, error));
                }
                else {
                    throw error;
                }
            }
        }
    });
}
function buildWarningMessage(jsonFile, error) {
    const relativeJsonFile = getRelativePathFromWorkspace(jsonFile);
    const mainWarning = `Failed to submit dependency graph ${relativeJsonFile}.\n${String(error)}`;
    if (error.message === 'Resource not accessible by integration') {
        return `${mainWarning}
Please ensure that the 'contents: write' permission is available for the workflow job.
Note that this permission is never available for a 'pull_request' trigger from a repository fork.
        `;
    }
    return mainWarning;
}
function submitDependencyGraphFile(jsonFile) {
    return __awaiter(this, void 0, void 0, function* () {
        const octokit = getOctokit();
        const jsonContent = fs_1.default.readFileSync(jsonFile, 'utf8');
        const jsonObject = JSON.parse(jsonContent);
        jsonObject.owner = github.context.repo.owner;
        jsonObject.repo = github.context.repo.repo;
        const response = yield octokit.request('POST /repos/{owner}/{repo}/dependency-graph/snapshots', jsonObject);
        const relativeJsonFile = getRelativePathFromWorkspace(jsonFile);
        core.notice(`Submitted ${relativeJsonFile}: ${response.data.message}`);
    });
}
function downloadDependencyGraphs() {
    return __awaiter(this, void 0, void 0, function* () {
        const workspaceDirectory = layout.workspaceDirectory();
        const findBy = github.context.payload.workflow_run
            ? {
                token: getGithubToken(),
                workflowRunId: github.context.payload.workflow_run.id,
                repositoryName: github.context.repo.repo,
                repositoryOwner: github.context.repo.owner
            }
            : undefined;
        const artifactClient = new artifact_1.DefaultArtifactClient();
        const downloadPath = path.resolve(workspaceDirectory, 'dependency-graph');
        const dependencyGraphArtifacts = (yield artifactClient.listArtifacts({
            latest: true,
            findBy
        })).artifacts.filter(candidate => candidate.name.startsWith(DEPENDENCY_GRAPH_PREFIX));
        for (const artifact of dependencyGraphArtifacts) {
            const downloadedArtifact = yield artifactClient.downloadArtifact(artifact.id, {
                path: downloadPath,
                findBy
            });
            core.info(`Downloading dependency-graph artifact ${artifact.name} to ${downloadedArtifact.downloadPath}`);
        }
        return findDependencyGraphFiles(downloadPath);
    });
}
function findDependencyGraphFiles(dir) {
    return __awaiter(this, void 0, void 0, function* () {
        const globber = yield glob.create(`${dir}/dependency-graph-reports/*.json`);
        const graphFiles = globber.glob();
        return graphFiles;
    });
}
function getOctokit() {
    return github.getOctokit(getGithubToken());
}
function getGithubToken() {
    return core.getInput('github-token', { required: true });
}
function getRelativePathFromWorkspace(file) {
    const workspaceDirectory = layout.workspaceDirectory();
    return path.relative(workspaceDirectory, file);
}
function getShaFromContext() {
    const context = github.context;
    const pullRequestEvents = [
        'pull_request',
        'pull_request_comment',
        'pull_request_review',
        'pull_request_review_comment'
    ];
    if (pullRequestEvents.includes(context.eventName)) {
        const pr = context.payload.pull_request;
        return pr.head.sha;
    }
    else {
        return context.sha;
    }
}
function getJobCorrelator() {
    return constructJobCorrelator(github.context.workflow, github.context.job, (0, input_params_1.getJobMatrix)());
}
function constructJobCorrelator(workflow, jobId, matrixJson) {
    const matrixString = describeMatrix(matrixJson);
    const label = matrixString ? `${workflow}-${jobId}-${matrixString}` : `${workflow}-${jobId}`;
    return sanitize(label);
}
exports.constructJobCorrelator = constructJobCorrelator;
function describeMatrix(matrixJson) {
    core.debug(`Got matrix json: ${matrixJson}`);
    const matrix = JSON.parse(matrixJson);
    if (matrix) {
        return Object.values(matrix).join('-');
    }
    return '';
}
function sanitize(value) {
    return value
        .replace(/[^a-zA-Z0-9_-\s]/g, '')
        .replace(/\s+/g, '_')
        .toLowerCase();
}
